// extracted by mini-css-extract-plugin
export var addToCartButton = "_np-b";
export var arrowButtonContainer = "_np-9";
export var arrowButtonIcon = "_np-a";
export var carouselArrowButton = "_np-6";
export var carouselElementContainer = "_np-1";
export var galleryThumbnail = "_np-d";
export var galleryThumbnailImage = "_np-e";
export var left = "_np-7";
export var productDisplayCarouselContainer = "_np-0";
export var productTileContainer = "_np-2";
export var productTileImage = "_np-4";
export var productTileImageContainer = "_np-3";
export var productTileTitle = "_np-5";
export var right = "_np-8";
export var sliderOverflow = "_np-c";